/**
 * Created by anthony on 7/3/14.
 */

var zillowDataModel = angular.module('zillowDataModel', ['familyModel']);
zillowDataModel.factory('zillowDataModelFactory', function(FamilyModelFactory, ApplicationService, RestService, $q){
    var ZillowDataModel = function(familyID){
        this.familyID = familyID;
        this.endpoint = "/ZillowData";
        this.dataProperty = "zillowData"
    }
    ZillowDataModel.prototype = new FamilyModelFactory();
    ZillowDataModel.prototype.parent = FamilyModelFactory.prototype;


    ZillowDataModel.prototype.resolveData = function(recordID) //Abstract
    {
        var self = this;
        var deferred = $q.defer();
        $q.all([
                RestService.get("/api/family/" + this.familyID + "/ZillowData/" + recordID),
            ]).then(function (results) {
                self.data = results[0].data;
            deferred.resolve(results);
        });
        return deferred.promise;
    }



    ZillowDataModel.prototype.get = function() //Abstract
    {
        return this.data;
    }


    return ZillowDataModel;
});